export enum AggregationEnum {
  Sum = 'SUM',
  Min = 'MIN',
  Max = 'MAX',
  Avg = 'AVG',
  Count = 'COUNT',
  Stddev = 'STDDEV',
  CountDistinct = 'COUNT_DISTINCT',
  StringAgg = 'STRING_AGG',
  StringAggDistinct = 'STRING_AGG_DISTINCT',
}
export interface AggregationOption {
  name: string;
  description: string;
}
export const AggregationOptions = {
  SUM: {
    name: 'SUM',
    description: 'Returns the total sum of a numeric column.',
  },
  MIN: {
    name: 'MIN',
    description: 'Returns the smallest value of the selected column.',
  },
  MAX: {
    name: 'MAX',
    description: 'Returns the biggest value of the selected column.',
  },
  AVG: {
    name: 'AVG',
    description: 'Returns the average value of a numeric column.',
  },
  COUNT: {
    name: 'COUNT',
    description: 'Returns the number of rows that matches a specified criteria.',
  },
  STDDEV: {
    name: 'STDDEV',
    description: 'Returns the standard deviation of the selected column.',
  },
  COUNT_DISTINCT: {
    name: 'COUNT_DISTINCT',
    description: 'Returns the distinct values in the selected column.',
  },
  STRING_AGG: {
    name: 'STRING_AGG',
    description: 'Returns a value obtained by concatenating non-NULL values.',
  },
  STRING_AGG_DISTINCT: {
    name: 'STRING_AGG_DISTINCT',
    description: 'Returns a value obtained by concatenating all distinct non-NULL values only.',
  },
};

export class AggregationModel {
  constructor(public columns: AggregationColumn[] = [new AggregationColumn()], public groupBy: string[] = []) {}
}

export class AggregationColumn {
  constructor(public name = '', public alias = '', public func: AggregationEnum = AggregationEnum.Count) {}
}
